import { APIv1 } from "../services/API.js";
import { getToken } from "./authHelper.js";
import { devError } from "./logger.js";
const verifyToken = async (token) => {
  try {
    if (!token) {
      token = await getToken();
      if (!token) return false; // No token found
    }
    const response = await APIv1.post("/auth/verify-token", {
      token,
    });

    return response.data; // Backend should return { valid: true } if token is valid
  } catch (error) {
    devError("Error verifying token:", error);
    return false; // Invalid or expired token
  }
};

// ✅ Export function so it can be imported elsewhere
export { verifyToken };
